module.exports = __webpack_public_path__ + "static/media/board-limit.0df38cca.svg";